"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.assign.js");
var _vue = _interopRequireDefault(require("vue"));
var _ImagePreview = _interopRequireDefault(require("./ImagePreview"));
var _utils = require("../utils");
var instance;
var adapter;
if (!_utils.isServer) {
  adapter = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}

var defaultConfig = {
  images: [],
  texts: [],
  loop: true,
  value: true,
  className: '',
  lazyLoad: false,
  showIndex: true,
  showClose: false,
  asyncClose: false,
  startPosition: 0,
  showIndicators: false,
  adaptHeight: false,
  onError: null,
  adaptZljApp: false
};
var initInstance = function initInstance() {
  if (_utils.isServer) {
    return;
  }
  instance = new (_vue.default.extend(_ImagePreview.default))({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};
var ImagePreview = function ImagePreview(images, startPosition) {
  if (startPosition === void 0) {
    startPosition = 0;
  }
  if (_utils.isServer) {
    return;
  }
  var options = Array.isArray(images) ? {
    images: images,
    startPosition: startPosition
  } : images;
  var imgUrls = (options.images || []).join('|');
  var selectedIndex = '' + (options.startPosition || '0');
  if (options.adapter) {
    adapter = options.adapter;
  }
  if ((adapter.in('zz') || adapter.in('checkapp') || adapter.in('zzhunter')) && options.adaptApp) {
    if (options.withVideo) {
      adapter.wrap('enlargeImgsOrVideo')({
        imgUrls: imgUrls,
        videoVos: options.videoVos,
        selectedIndex: selectedIndex
      });
    } else {
      adapter.enlargeImage({
        imgUrls: imgUrls,
        selectedIndex: selectedIndex
      });
    }
    return;
  }
  if (adapter.in('zlj') && options.adaptZljApp) {
    adapter.wrap('browsePicture')({
      list: imgUrls.split('|'),
      index: selectedIndex + ''
    }, function () {});
    return;
  }
  if (_utils.isWechat && options.adaptWeixin) {
    adapter.enlargeImage({
      imgUrls: imgUrls,
      selectedIndex: selectedIndex
    }, function () {
      console.log('wx.previewImage');
    });
    return;
  }
  if (options.withVideo) {
    options.images = [].concat(options.videoVos, options.images);
  }
  if (options.withMedia) {
    options.images = options.mediaList;
  }
  if (!instance) {
    initInstance();
  }
  Object.assign(instance, defaultConfig, options);
  instance.$once('input', function (show) {
    instance.value = show;
  });
  if (options.onClose) {
    instance.$once('close', options.onClose);
  }
  return instance;
};
ImagePreview.install = function () {
  _vue.default.use(_ImagePreview.default);
};
_vue.default.prototype.$imagePreview = ImagePreview;
var _default = ImagePreview;
exports.default = _default;